<template>
  <div>
 
  <CCard>
   <CCardHeader>
            <strong>Courses</strong>
          </CCardHeader>
        
    <CCardBody>
   <CDataTable :items="items"  
    :fields="fields"
      striped
      clickable-rows
    
       table-filter
        items-per-page-select
      :items-per-page="20"
       sorter
       ref="vuetable"
      pagination
      >
     
       <template #index="data">
       <td>
         {{data.index +1}}
         </td>
     </template>
 <template #metaStream="{ item }">
                  <td v-if="item.metaStream">
                    {{
                      item.metaStream.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
                <template #MetaCategory="{ item }">
                  <td v-if="item.category">
                    {{
                      item.category.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
                 <template #grade="{ item }"> 
                   <td v-if="item.grade">
                    {{
                      item.grade.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template> 
                  <template #actualPrice="{ item }">
                  <td v-if="item.course">
                    {{
                      item.course.actualPrice
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
                  <template #discount="{ item }">
                  <td v-if="item.course">
                    {{
                      item.course.discount
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
                  <template #name="{ item }">
                  <td v-if="item.course">
                    {{
                      item.course.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
             <template #createdTime="{ item }">
                  <td v-if="item.course">
                    {{
                      item.course.createdTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

                 <template #modifiedTime="{ item }">
                  <td v-if="item.course">
                    {{
                      item.course.modifiedTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
       <!-- <template #show_details="{item}">
        <td class="py-2">
        <CDropdown
                  togglerText="Actions"
                  color="info"
                >
                   <CDropdownItem :to="{name: 'Job Tasks', params: { craneId: item. craneId, mode: 'view'}}">Job Tasks</CDropdownItem> 
           
                </CDropdown> 

        </td>
      </template> -->
      </CDataTable>
    </CCardBody>
  </CCard> 

 <CCard>
    <CCardHeader>
            <strong>Classes</strong>
          </CCardHeader>
        

          <CCardBody>
          <CDataTable :items="worksite"  
    :fields="field"
      striped
      clickable-rows
   
       table-filter
        items-per-page-select
      :items-per-page="20"
       sorter
       ref="vuetable"
      pagination
      >
         
       
       <template #index="data">
       <td>
         {{data.index +1}}
         </td>
     </template>
  <template #Stream="{ item }">
                  <td v-if="item.metaStream">
                    {{
                      item.metaStream.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template> 
                 <template #Category="{ item }">
                  <td v-if="item.category">
                    {{
                      item.category.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
                 <template #metagrade="{ item }"> 
                   <td v-if="item.grade">
                    {{
                      item.grade.name
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template> 
                
  <!-- <template #classInitiationTime="{ item }">
                  <td v-if="item.courseClass">
                    {{
                      item.courseClass.classInitiationTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template> -->
             <template #createdTime="{ item }">
                  <td v-if="item.courseClass">
                    {{
                      item.courseClass.createdTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

                 <template #modifiedTime="{ item }">
                  <td v-if="item.courseClass.modifiedTime">
                    {{
                      item.courseClass.modifiedTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template>  

                 <template #className="{ item }">
                  <td v-if="item.courseClass">
                    {{
                      item.courseClass.className
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
                <template #classDuration="{ item }">
                  <td v-if="item.courseClass">
                    {{
                      item.courseClass.classDuration
                       
                    }}
                  </td>
                  <td v-else>--</td>
                </template>
       <!-- <template #show_details="{item}">
        <td class="py-2">
        <CDropdown
                  togglerText="Actions"
                  color="info"
                >
                   <CDropdownItem :to="{name: 'Labours', params: { progressId: item. progressId}}">Labours</CDropdownItem> 
                     <CDropdownItem :to="{name: 'Plants', params: { progressId: item. progressId}}">Plants</CDropdownItem> 
           
                </CDropdown> 

        </td>
      </template> -->
      </CDataTable>
            
          </CCardBody>
          
        
          <CCardFooter align="right">
        
            <CButton class="mr-2" type="Cancel" size="sm" color="danger"  @click="cancel()">
              <CIcon name="cil-ban" /> Cancel
            </CButton>
          </CCardFooter>
 </CCard>
 </div>
</template>

<script>
const fields = [
  { key: "index",label: "#"},
//  { key: "subjectId", _style: "min-width:200px" },
  { key: "name", label: "Course Name", _style: "min-width:100px;" },
  { key: "MetaCategory", label: "Category Name", _style: "min-width:100px;" },
 { key: "metaStream", label: "Stream Name", _style: "min-width:100px;" },
  { key: "grade", label: "Grade Name", _style: "min-width:100px;" },
  
 { key: "actualPrice", _style: "min-width:100px;" },


  { key: "discount", _style: "min-width:100px;" },
  // { key: "noOfUnits", _style: "min-width:100px;" },
  // { key: "iconId", label: "Icon", _style: "min-width:100px;" },
  // { key: "courseName", _style: "min-width:100px;" },
  // { key: "courseStreamName", _style: "min-width:100px;" },
 
   { key: "createdTime",label: "Created Date & Time", _style: "min-width:100px;" },
  { key: "modifiedTime",label: "Modified Date & Time" ,_style: "min-width:100px;" },
  
//   { key: "show_details",
//     label: "",
//     _style: "width:1%",
//     sorter: false,
//     filter: false,
//   },
  
];

const field = [
  
 
  { key: "index",label: "#" },
//  
  { key: "className", label: "Class Name", _style: "min-width:100px;" },
 { key: "classDuration", _style: "min-width:100px;" },
   { key: "Category", label: "Category Name", _style: "min-width:100px;" },
 { key: "Stream", label: "Stream Name", _style: "min-width:100px;" },
  { key: "metagrade", label: "Grade Name", _style: "min-width:100px;" },
 // { key: "classStatus", _style: "min-width:100px;" },
  // { key: "unitName", _style: "min-width:100px;" },
  // { key: "thumbnail",  _style: "min-width:100px;" },
  // { key: "courseName", _style: "min-width:100px;" },
  // { key: "streamId", _style: "min-width:100px;" },
 // { key: "classInitiationTime", _style: "min-width:200px" },
   { key: "createdTime",label: "Created Date & Time", _style: "min-width:100px;" },
  { key: "modifiedTime",label: "Modified Date & Time" ,_style: "min-width:100px;" },
//  { key: "show_details",
//     label: "",
//     _style: "width:1%",
//     sorter: false,
//     filter: false,
//   },
];

import ConfirmationModal from "../../containers/ConfirmationModal";
export default {
  name: "UserSubscribs",
  components: {
    ConfirmationModal,
  },
  data() {
    return {
      items: [],
      worksite: [],
      
       fields,
        field,
    
      details: [],
      collapseDuration: 0,
    
    };
  },

  methods: {

    getInspections() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/user/course/"+this.$route.params.uid)
        .then((response) => response.json())
        .then((data) => (this.items = data));
    },
  
     getWorksiteProgress() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/user/class/"+this.$route.params.uid)
        .then((response) => response.json())
        .then((data) => (this.worksite = data));
    },
    // getOverallScore() {
    //  fetch(process.env.VUE_APP_API_HOST + "/emapp/web/secure/get/OverallScores/"+this.$route.params.jobId)
    //     .then((response) => response.json())
    //     .then((data) => (this.overallScore = data));
    // },
     cancel() {
  
     this.$router.push({ name: "AppUsers" });
    },
  },
  mounted() {
   this.getInspections();
    //this.getOverallScore();
    this.getWorksiteProgress();
  },
};
</script>